import { Injectable } from '@angular/core';
import { QuerifyService } from '@core/services/querify.service';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Equipment, PagedResult } from '../../interfaces';
import { Queries } from './queries';

@Injectable({
  providedIn: 'root'
})
export class EquipmentsApi {
  constructor(private apollo: Apollo, private queries: Queries, private querify: QuerifyService) { }

  getEquipments(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);
    return this.apollo
      .query({
        query: this.queries.getEquipments(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['equipments'];
        })
      );
  }

  searchOne(id: String): Observable<Equipment> {
    return this.apollo
      .query({
        query: this.queries.getEquipment(),
        variables: { id: id }
      })
      .pipe(
        map(({ data }) => {
          return data['equipment'];
        })
      );
  }

  getFiltersData(): Observable<any> {
    return this.apollo
      .query({
        query: this.queries.getFiltersData()
      })
      .pipe(
        map(({ data }) => {
          return data;
        })
      );
  }

  searchEquipmentType(query?): Observable<PagedResult> {
    const options = this.querify.transformOptions(query);
    return this.apollo
      .query({
        query: this.queries.getEquipmentsTypes(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['equipmentsTypes'];
        })
      );
  }

  searchOneEquipmentType(id: String): Observable<any> {
    return this.apollo
      .query({
        query: this.queries.getEquipmentType(),
        variables: { id: id }
      })
      .pipe(
        map(({ data }) => {
          return data['equipmentType'];
        })
      );
  }
}
